import React from 'react'
import { Blog } from '../../component/blog/Blog'

export default function BlogPage() {
  return (
    <>
      <Blog />
    </>
  )
}
